import { useEffect } from 'react';

/**
 * Hook para detectar atalhos de busca (Cmd+K, Ctrl+K ou /)
 * @param onOpen - Função a ser executada quando o atalho for acionado
 */
export const useSearchHotkeys = (onOpen: () => void) => {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      // 1. Ignorar se o usuário já estiver digitando em um input, textarea ou contenteditable
      const target = event.target as HTMLElement;
      const isTyping = target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable;

      if (isTyping) return;

      // 2. Detectar Cmd+K (Mac) ou Ctrl+K (Windows/Linux)
      // metaKey é a tecla Command no Mac
      const isCmdK = (event.metaKey || event.ctrlKey) && event.key === 'k';

      // 3. Detectar a tecla barra "/"
      const isSlash = event.key === '/';

      if (isCmdK || isSlash) {
        // Previne o comportamento padrão (ex: digitar "/" ou focar na barra do navegador)
        event.preventDefault();
        onOpen();
      }
    };

    // Adiciona o listener na janela
    window.addEventListener('keydown', handleKeyDown);

    // Remove o listener ao desmontar
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [onOpen]);
};
